module.exports = ".navbar-default .navbar-collapse, .navbar-default .navbar-form {\n    border-color: #ffffff;\n}\n\n.navbar-default {\n    background-color: #ffffff;\n    border-color: #ffffff;\n}\n\n.navbar-default .navbar-nav>li>a {\n    color: #444;\n}\n\n.navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover {\n    color: #111;\n    background-color: transparent;\n}\n\n.navbar-nav i.fa {\n    font-size: 24px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/navigation.component.css
// module id = ./src/app/navigation/navigation.component.css
// module chunks = main